export enum SymbolType {
    HP_4 = 28001,
    HP_3 = 28002,
    HP_2 = 28003,
    HP_1 = 28004,
    LP_5 = 28005,
    LP_4 = 28006,
    LP_3 = 28007,
    LP_2 = 28008,
    LP_1 = 28009,
}
